import React, { useState } from 'react';
import useWindowSize from './useWindowSize';

import basDegree from '../assets/certs/basDegree.png';
import ataDegree from "../assets/certs/ataDegree.png";
import CourseraAIEssentials from "../assets/certs/CourseraAIEssentials.png";
import GoogleCloudCyberSecurityCert from "../assets/certs/GoogleCloudCyberSecurityCert.png";
import GoogleDataAnalytics3 from "../assets/certs/GoogleDataAnalytics3.png";

const Credentials = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const isMobile = useWindowSize().isMobile;

  const credentialList = [
    { id: 1, name: 'Associates Degree', url: ataDegree },
    { id: 2, name: 'Bachelors Degree', url: basDegree },
    { id: 3, name: 'Google Cloud Cyber Security Certificate', url: GoogleCloudCyberSecurityCert },
    { id: 4, name: 'AI Essentials', url: CourseraAIEssentials },
    { id: 5, name: 'Google Data Analytics', url: GoogleDataAnalytics3 },
  ];

  const credentialDiv = {
    display: 'flex',
    flexDirection: 'column',
    gap: isMobile ? '15px' : '20px',
    padding: isMobile ? '1.5rem 1rem' : '2.5rem',
    boxSizing: 'border-box',
    width: '100%',
    backgroundColor: 'rgba(18, 18, 18, 0.55)',
    backdropFilter: 'blur(16px) saturate(120%)',
    boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.5)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '16px',
    WebkitMaskImage: 'linear-gradient(to bottom, black 80%, transparent 100%)',
    maskImage: 'linear-gradient(to bottom, black 80%, transparent 100%)',
  }

  const credentialUl = {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr 1fr',
    columnGap: '20px',
    rowGap: '15px',
    listStyle: 'none',    
    cursor: 'pointer',
    padding: '0',
    margin: '0',
    width: '100%',
  }

  const liImg = (isActive) => ({
    padding: '12px 15px',
    backgroundColor: isActive ? 'rgba(255, 255, 255, 0.15)' : 'rgba(255, 255, 255, 0.05)',
    border: isActive ? '1px solid rgba(255, 255, 255, 0.3)' : '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '10px',
    textAlign: 'center',
    color: '#fff',
    fontSize: isMobile ? '0.9em' : '1.1em',
    fontWeight: 'bold',
    transition: 'background-color 0.2s, border-color 0.2s',
  })

  const imgDiv = {
    border: '1px solid rgba(255, 255, 255, 0.15)',
    borderRadius: '12px',
    backgroundColor: 'rgba(0, 0, 0, 0.25)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '15px',
    minHeight: isMobile ? '220px' : '380px',
    boxSizing: 'border-box',
    width: '100%',
  }
  
  const imageView = {
    maxWidth: '100%',
    maxHeight: isMobile ? '40vh' : '55vh',
    objectFit: 'contain',
    borderRadius: '8px',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.4)',
  }

  const pInstruction = {
    color: 'rgba(255, 255, 255, 0.6)',
    fontSize: isMobile ? '0.95em' : '1.15em',
    textAlign: 'center',
    margin: '0',
  }

  return (
    <div style={credentialDiv}>
      <ul style={credentialUl}>
        {credentialList.map((item) => (
          <li 
            key={item.id} 
            onClick={() => setSelectedImage(item.url)}
            style={liImg(selectedImage === item.url)}
          >
            {item.name}
          </li>
        ))}
      </ul>

      <div style={imgDiv}>
        {selectedImage ? (
          <img src={selectedImage} alt="Credential Preview" style={imageView} />
        ) : (
          <p style={pInstruction}>Select a credential above to view the certificate.</p>
        )}
      </div>
    </div>
  );
};

export default Credentials;
